import { render } from "./javascript-chapter-3.vue?vue&type=template&id=5dddc6c8"
import script from "./javascript-chapter-3.vue?vue&type=script&lang=js"
export * from "./javascript-chapter-3.vue?vue&type=script&lang=js"

import "./javascript-chapter-3.vue?vue&type=style&index=0&id=5dddc6c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__